'use client'

import { useMemo } from 'react'
import IconCommute from '@icon/aboutArea/commute.svg?url'
import IconContour from '@icon/aboutArea/contour.svg?url'
import IconFlood from '@icon/aboutArea/flood.svg?url'
import IconSchool from '@icon/aboutArea/school.svg?url'
import IconStatistics from '@icon/aboutArea/statistics.svg?url'
import IconUnderground from '@icon/aboutArea/underground.svg?url'
import IconUnitaryPlan from '@icon/aboutArea/unitary-plan.svg?url'
import Image from 'next/image'
import { MENU_ITEM_TYPE } from './index'
import { useAboutAreaMenuControlContext } from './context'
import { map } from 'lodash-es'
import classNames from 'classnames'

export default function AboutAreaMenu({
  isVillage = false,
  className
}) {

  const { hasCensus, regionId, isRural, setCurrentMenu, propertyId } = useAboutAreaMenuControlContext()
  // 菜单列表
  const menus = useMemo(() => {
    const menuItem = {
      school: { label: 'Schools', value: MENU_ITEM_TYPE.school, icon: IconSchool },
      commute: { label: 'Commute', value: MENU_ITEM_TYPE.commute, icon: IconCommute },
      unitaryPlan: { label: 'Unitary plan Zone', value: MENU_ITEM_TYPE.unitaryPlan, icon: IconUnitaryPlan },
      services: { label: 'Underground services', value: MENU_ITEM_TYPE.services, icon: IconUnderground },
      flood: { label: 'Flood assessment', value: MENU_ITEM_TYPE.flood, icon: IconFlood },
      contour: { label: 'Contours', value: MENU_ITEM_TYPE.contour, icon: IconContour },
      statistics: { label: 'Statistics', value: MENU_ITEM_TYPE.statistics, icon: IconStatistics },
    }
    const res = isVillage ? [menuItem.commute] : [menuItem.school, menuItem.commute]
    // 只有Auckland下面才有
    // https://hougarden.atlassian.net/browse/HG-5239
    if (!isVillage && [35].includes(regionId)) {
      res.push(menuItem.unitaryPlan, menuItem.services)
    }
    if (
      // propertyId为1812938,2153956,1212203,1172075的这个房子，要求不显示淹水区逻辑
      // https://7thave.atlassian.net/browse/HT-4034
      // https://7thave.atlassian.net/browse/HT-4125
      // https://7thave.atlassian.net/browse/HT-4180
      // https://7thave.atlassian.net/browse/HT-4891
      ![1812938, 2153956, 1212203, 1172075].includes(propertyId)
      && ([35, 36, 37].includes(regionId) || ([39].includes(regionId) && isRural))
    ) {
      res.push(menuItem.flood)
    }
    // 只有奥克兰和汉密尔顿才有Contours
    if ([35, 36, 37, 39].includes(regionId) && isRural && !isVillage) {
      res.push(menuItem.contour)
    }
    if (hasCensus) {
      res.push(menuItem.statistics)
    }
    return res
  }, [hasCensus, regionId, isRural, isVillage, propertyId])

  const menuClickHandle = function (val) {
    return () => {
      setCurrentMenu(val)
    }
  }

  return (
    <ul className={classNames('bg-white rounded-sm flex overflow-auto shadow-card sm:w-242 sm:overflow-hidden sm:block', className)}>{
      map(menus, ({ value, icon, label }) => (
        <li
          className='h-60 flex flex-col items-center justify-center px-16 border-l first:border-l-0 cursor-pointer sm:border-t sm:first:border-t-0 sm:flex-row sm:justify-start'
          onClick={menuClickHandle(value)}
          key={value}
        >
          <Image src={icon} width={32} height={32} alt='icon' unoptimized></Image>
          <span className='text-sm text-font sm:ml-8 whitespace-nowrap sm:text-base'>{label}</span>
        </li>
      ))
    }</ul>
  )

}